import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import MuiSelect from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';

const useStyles = makeStyles((theme) => ({
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
}));

const Select = ({
    value,
    setValue,
    label,
    labelNode,
    values,
    disabled,
    isLoading,
    fullWidth = true,
    error = false,
    helperText = '',
    readOnly = false
}) => {
    const classes = useStyles();
    const labelId = `${String(label).replace(' ', '')}-select-label`;
    const handleChange = (event) => {
        setValue(event.target.value);
    };
    // When a JSX labelNode is used, MUI can't auto-detect shrink from the node;
    // force shrink so the label always floats above the selected value.
    const shrink = labelNode ? true : undefined;

    return (
        <FormControl disabled={disabled} margin="normal" error={error} fullWidth={fullWidth}>
            <InputLabel id={labelId} shrink={shrink}>
                {labelNode || label}
            </InputLabel>
            <MuiSelect
                labelId={labelId}
                value={isLoading ? '' : value}
                onChange={handleChange}
                displayEmpty
                className={classes.selectEmpty}
                inputProps={{ readOnly }}
            >
                {values.map((item) => (
                    <MenuItem value={item.key} key={item.key}>
                        {item.value}
                    </MenuItem>
                ))}
            </MuiSelect>
            <FormHelperText>{helperText}</FormHelperText>
        </FormControl>
    );
};

export default Select;
